@let editingNode = editingNodeSg();

@if (editingNode) {
  <atn-ds-slideout-overlay [name]="editingNode.label + ' details'">
    <div class="atn-summit-org-chart-node-panel">
      <atn-summit-org-chart-node-panel-body />
      <atn-summit-org-chart-node-panel-footer />
    </div>
  </atn-ds-slideout-overlay>
}
